"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ThumbsDown = function ThumbsDown(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 19 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 19 20",
    scale: width / 19,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.203 8.789c.365.625.547 1.276.547 1.953 0 .886-.326 1.667-.977 2.344a3.18 3.18 0 0 1-2.382 1.016h-1.407a4.9 4.9 0 0 1 .352 1.796c0 1.38-.339 2.422-1.016 3.125-.65.651-1.562.977-2.734.977-.73 0-1.302-.365-1.719-1.094-.234-.416-.469-1.094-.703-2.031-.13-.651-.247-1.029-.352-1.133-.286-.286-.742-.84-1.367-1.66S5.378 12.734 5.117 12.5h-.273c-.13.182-.287.332-.469.45a1.13 1.13 0 0 1-.625.175h-2.5c-.339 0-.632-.124-.879-.371A1.201 1.201 0 0 1 0 11.875V2.5c0-.339.124-.632.371-.879s.54-.371.879-.371h2.5c.312 0 .586.104.82.312H5c.286 0 .586-.052.898-.156.209-.052.534-.169.977-.351C7.682.716 8.346.482 8.867.352A12.54 12.54 0 0 1 11.914 0h.86c1.458 0 2.565.352 3.32 1.055.703.625 1.067 1.51 1.093 2.656.26.365.45.781.567 1.25.117.469.15.924.098 1.367.416.781.533 1.602.351 2.461zM2.5 11.562c.26 0 .482-.09.664-.273a.904.904 0 0 0 .273-.664.904.904 0 0 0-.273-.664.904.904 0 0 0-.664-.274.904.904 0 0 0-.664.274.904.904 0 0 0-.274.664c0 .26.092.482.274.664a.904.904 0 0 0 .664.273zm12.89.665c.417 0 .769-.157 1.055-.47.287-.312.43-.65.43-1.015a1.88 1.88 0 0 0-.293-1.015c-.195-.313-.384-.47-.566-.47.286-.312.423-.722.41-1.23-.013-.507-.215-.957-.606-1.347.209-.391.248-.814.117-1.27-.13-.456-.351-.775-.664-.957.13-.911-.013-1.575-.43-1.992-.364-.39-.924-.586-1.679-.586h-1.445c-.677 0-1.367.091-2.07.273-.417.105-1.016.287-1.797.547-.625.235-1.094.39-1.407.47-.52.13-1.002.194-1.445.194v7.266h.43c.338 0 .755.26 1.25.781.286.287.716.82 1.289 1.602.547.729.924 1.198 1.133 1.406.286.286.507.638.664 1.055.078.26.169.65.273 1.172.078.39.143.664.195.82.105.286.222.508.352.664.807 0 1.354-.247 1.64-.742.157-.313.235-.808.235-1.485 0-.338-.065-.677-.195-1.015a9.637 9.637 0 0 0-.391-.86c-.182-.364-.3-.638-.352-.82a2.716 2.716 0 0 1-.195-.976h4.063z",
    id: "thumbsDown"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#thumbsDown"
  }));
};

var _default = ThumbsDown;
exports["default"] = _default;
module.exports = exports["default"];